<template>
  <div style="padding: 1vw">
    <div class="container-wrapper">
      <div class="page-title-container">
        <div class="page-title">
          <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
            메뉴 관리
          </h3>
          <span class="pageDesc">
            고객사에 노출할 메뉴 및 권한을 등록 및 수정합니다.
          </span>
        </div>
        <div style="display: flex; align-items: center;">
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <div class="search-filter-container table-info-filter">
        <div class="search-filter-row">
          <div class="search-filter-title">
            검색어
          </div>
          <div class="search-filter-content">
            <select class="search-select" v-model="searchFilter.filter">
              <option value="">메뉴명</option>
            </select>
            <div class="search-input-container">
              <div class="search-icon">
                <i
                  class="fa-regular fa-magnifying-glass"
                />
              </div>
              <input 
                type="text"
                class="search-input-text"
                v-model="searchFilter.keyword"
                @keyup.enter="search"
                placeholder="검색어를 입력하세요"
              />
            </div>
            <button
              class="search-btn"
              @click="search"
            >
              검색
            </button>
            <button
              class="init-btn"
              @click="initFilter"
            >
              초기화
            </button>
          </div>
        </div>
       
        <div class="search-filter-row">
          <div class="search-filter-title">
            분류
          </div>
          <div class="search-filter-content radioWrap">
            <div class="radio-component" v-for="(item, i) in computedRoles" :key="item.key">
              <input 
              type="checkbox" 
              :value="item.key"
              :id="item.key"
              v-model="searchFilter.selectedRoles" 
              @change="search"
              /> 
              <label :for="item.key">{{ item.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <div class="col-xs-12 table-info-filter">
        <div class="total-div">
          <p>
          </p>
        </div>
        <div class="search-container">
          <select class="search-select" v-model="rowsPerPage" @change="search">
            <option :value="10">10개씩 보기</option>
            <option :value="20">20개씩 보기</option>
            <option :value="50">50개씩 보기</option>
          </select>
          <button 
            @click="addMenu"
            type="button" 
            class="header-btn active btn-hover"
            data-bs-toggle="modal"
            data-bs-target="#menuWModal"
          >
            <i class="fa-solid fa-plus"/>
            메뉴 등록
          </button>
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">{{ computedNoResultMessage }}</div>
        </template>
      </a-table>
      <pagination 
        :page-info="paginationData"
        page-name="CertificateList"
        @change-page="paginationHandler"
      />
    </div>
  </div>
  <!-- 삭제 모달 -->
  <div
    class="modal fade"
    id="deleteyesno"
    tabindex="-1"
    aria-labelledby="resetModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      style="justify-content: center !important"
    >
      <div
        class="modal-content"
        style="width: 70% !important; padding-top: 0.5vw"
      >
        <div class="modal-body" style="display: flex; flex-direction: column">
          <div style="text-align: center; padding-top: 1rem">
            <h4>메뉴 삭제</h4>
            <h6>해당 메뉴를 삭제하시겠습니까?</h6>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 2rem">
            <button
              style="margin-right: 1vw;"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
            취소
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click="deleteMenu()"
            >
            삭제
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <menu-w 
    :roles="computedRoles"
  />
  <menu-m 
    :roles="computedRoles"
    :data="menuDetailData"
  />
</template>
<script>
import MenuW from './components/MenuW';
import MenuM from './components/MenuM';
import Pagination from '@/views/components/Pagination.vue';
import enums from '@/enums/common.enums';

import {
  convertDate,
  openDialog,
  oneBtnDialog,
  convertDateTime,
  phoneNumberFormatter,
  convertMonthAndYearText,
  roleConverter,
  convertYnToKorean,
} from '@/utils/utils';

export default {
  name: 'MenuManage',
  components: { 
    MenuW,
    MenuM,
    Pagination,
  },
  computed: {
    computedNoResultMessage() {
    console.log(this.calledApiTimes)
      if(this.calledApiTimes <= 1) {
        return '아직 등록된 메뉴가 없습니다.';
      } else {
        
        return '검색 결과가 없습니다.';
      }
    },
    computedRoles() {
      const { HOSPITAL, MANUFACTURER } = enums().ROLES;
      return { HOSPITAL, MANUFACTURER };
    },
  },
  data() {
    return {
      // 목록 받아오는 변수
      responseData: [],
      convertDateTime,
      calledApiTimes: 0,
      selectedMenu: '',
      menuDetailData: {},
      searchFilter: {
        filter: '',
        keyword: '',
        selectedRoles: [],
      },

      // 페이지네이션 관련 변수     
      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        {
          key: 'index',
          title: '번호',
          dataIndex: 'index',
          align: 'center',
          // 
          width: 0,
        },
        {
          key: 'category',
          title: '카테고리',
          dataIndex: 'category',
          align: 'center',
          // 
        },
        {
          key: 'name',
          title: '메뉴명',
          dataIndex: 'name',
          align: 'center',
          // 
        },
        {
          key: 'role',
          title: '노출 대상',
          dataIndex: 'role',
          align: 'center',
          // 
          customRender: ({record}) => {
            return roleConverter(record.role);
          }
        },
        {
          key: 'link',
          title: 'URL',
          dataIndex: 'link',
          align: 'center',
          // 
        },
        {
          key: 'isNewWindow',
          title: '새 창에서 열기',
          dataIndex: 'isNewWindow',
          align: 'center',
          // 
          customRender: ({record}) => {
            
            return convertYnToKorean(record.isNewWindow);
          }
        },
        {
          key: 'iconDefaultUrl',
          title: '기본 이미지',
          dataIndex: 'iconDefaultUrl',
          align: 'center',
          // 
          customRender: ({record}) => {
            if(record.iconDefaultUrl) {
              return <div style="display: flex; align-items: center; justify-content: center;">
              <img src={record.iconDefaultUrl} style={{ width: '30px', height: '30px' }} />
              </div>;  
            } else {
              return <div />;
            }
            
          }
        },
        {
          key: 'iconActiveUrl',
          title: '활성화 시 이미지',
          dataIndex: 'iconActiveUrl',
          align: 'center',
          // 
          customRender: ({record}) => {
            if(record.iconActiveUrl) {
              return <div style="display: flex; align-items: center; justify-content: center;">
              <img src={record.iconActiveUrl} style={{ width: '30px', height: '30px' }} />
              </div>;  
            } else {
              return <div />;
            }
          }
        },
        {
          key: 'createAt',
          title: '생성 일시',
          dataIndex: 'createAt',
          align: 'center',
          // 
          customRender: ({record}) => {
            return this.convertDateTime(record.createAt);
          }
        },
        {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          customRender: ({ record }) => {
            if(record.deleteYn === 'N') {
              return <div
                    style="display: flex; gap: 8px; justify-content: center;"
                  >
                  <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#menuMModal"
                    class="certi-custom-btn"
                    onClick={() => {this.getMenuDetail(record._id)}}
                    >
                    수정
                  </div>
                    <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteyesno"
                    class="certi-custom-btn"
                    onClick={() => {this.selectMenu(record._id)}}
                    >
                    삭제
                  </div>
                </div>
            } else {
              return <div style="color: red !important;">삭제됨</div>
            }
          }
        },
      ],
    };
  },
  created() {

  },
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    convertDate,
    convertMonthAndYearText,
    phoneNumberFormatter,
    handleResizeColumn(w, col) {
      col.width = w;
    },

    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getMenuList();    
    },
    // 주요 API
    // 전체 목록 가져오기

    async getMenuList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      if(this.searchFilter.filter) obj.search = this.searchFilter.filter;
      if(this.searchFilter.keyword) obj.condition = this.searchFilter.keyword;
      if(this.searchFilter.selectedRoles.length > 0) obj.roles = this.searchFilter.selectedRoles;
      try {
        const response = await this.$apiInstance.post(`/menus/list`, obj);
        if(response.status !== 200 && response.status !== 201) {
          throw new Error('서버와의 통신에 문제가 발생했습니다.');
        };

        this.responseData = response.data.docs;
        this.listSize = response.data.totalDocs;
        this.paginationData.totalPages = response.data.totalPages;
        for (let i = 0; i < this.responseData.length; i++) {
          const item = this.responseData[i];
          item.index =
          this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMenuDetail(id) {
      try {
        const response = await this.$apiInstance.get(`/menus/${id}`);
        if(response.status === 200 || response.status === 201) {
          this.menuDetailData = response.data;
          this.menuDetailData.menuId = id;
        }
      } catch(error) {
        console.log(error);
      }
    },
    async selectMenu (id) {
      this.selectedMenu = id;
    },
    async deleteMenu() {
      try {
        const response = await this.$apiInstance.delete(`/menus/${this.selectedMenu}`);
        if(response.status === 200 || response.status === 201) {
          await openDialog("해당 메뉴가 삭제되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } 
      } catch(error) {
        console.log(error);
        await openDialog("메뉴 삭제에 실패하였습니다.", "error", "확인");
      }
    },
    async search() {
      if(!await this.validateSearchFilter()) return;
      this.paginationData.currentPage = 1;
      await this.getMenuList();
    },
    async initFilter() {
      this.searchFilter = {
        filter: '',
        keyword: '',
        selectedRoles: [],
      }
      await this.getMenuList();
    },
    async validateSearchFilter() {
      // 필터 걸어놓고 검색을 안함
      // 시작날짜가 과거날짜보다 큼
      if(this.searchFilter.startAt && !this.searchFilter.endAt) {
        return false;
      }
      if(this.searchFilter.startAt > this.searchFilter.endAt) {
        await oneBtnDialog('날짜 오류', '검색 시작일은 종료일보다 작아야 합니다.', false);
        return false;
      }
      return true;
    },


    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getMenuList();
    },

    // 인증서 상태 코드 텍스트로 변환

  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/menu-manage.scss';
</style>
